import React, { useState } from "react";
import ReactDOM from "react-dom";
import { useSelector } from "react-redux";
import {
  SubmenuLogo,
  Dropdown,
  LogoPositionLabel,
  SizeOptions,
  SizeOption,
  RadioButton,
  SizeLabel,
  PositionOptions,
  PositionOption,
  ApplyButton,
  CenterIcon,
} from "./ImageViewStyles.js";
import addLogo from "../../Components/Frames/addLogo.js";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
const SubmenuLogoComponent = ({
  highlightedImages,
  photos,
  originalImages,
  setOriginalImages,
  originalImagesLogo,
  setOriginalImagesLogo,
  setPhotos,
  setApprovedImages,
}) => {
  const logo = useSelector((state) => state.user.logo?.url);

  const [size, setSize] = useState("small");
  const [logoPosition, setLogoPosition] = useState("bottom-left");

  const handleAddLogo = async () => {
    const logoPromises = highlightedImages.map((photoId) => {
      return new Promise((resolve) => {
        const photo = photos.find((p) => p.id === photoId);
        if (photo) {
          // Call addLogo and then resolve the promise after it's done
          addLogo(
            photo,
            logoPosition,
            size,
            logo,
            photoId,
            originalImages,
            setOriginalImages,
            originalImagesLogo,
            setOriginalImagesLogo,
            setPhotos,
            setApprovedImages
          );

          // Update the state once the logo is added
          setPhotos((prevPhotos) =>
            prevPhotos.map((p) =>
              p.id === photoId
                ? { ...p, logoAdded: true, logoPosition, size }
                : p
            )
          );
        }
        resolve(); // Resolve after processing the photo
      });
    });

    // Wait until all the promises are resolved
    await Promise.all(logoPromises);

    // Set loading state to null after all operations are complete
    // Delay clearing loadingFrameId to see the effect
  };

  return ReactDOM.createPortal(
    <SubmenuLogo>
      <Dropdown>
        <LogoPositionLabel>Logo Size:</LogoPositionLabel>
        <SizeOptions>
          <SizeOption>
            <RadioButton
              type="radio"
              id="small"
              name="logo-size"
              value="small"
              checked={size === "small"}
              onChange={(e) => setSize(e.target.value)}
            />
            <SizeLabel htmlFor="small" size="small">
              S
            </SizeLabel>
          </SizeOption>
          <SizeOption>
            <RadioButton
              type="radio"
              id="medium"
              name="logo-size"
              value="medium"
              checked={size === "medium"}
              onChange={(e) => setSize(e.target.value)}
            />
            <SizeLabel htmlFor="medium" size="medium">
              M
            </SizeLabel>
          </SizeOption>
          <SizeOption>
            <RadioButton
              type="radio"
              id="large"
              name="logo-size"
              value="large"
              checked={size === "large"}
              onChange={(e) => setSize(e.target.value)}
            />
            <SizeLabel htmlFor="large" size="large">
              L
            </SizeLabel>
          </SizeOption>
        </SizeOptions>

        <LogoPositionLabel>Logo Position:</LogoPositionLabel>
        <PositionOptions>
          <PositionOption style={{ marginLeft: "10px", marginTop: "20px" }}>
            <RadioButton
              type="radio"
              id="top-left"
              name="logo-position"
              value="top-left"
              checked={logoPosition === "top-left"}
              onChange={(e) => setLogoPosition(e.target.value)}
            />
          </PositionOption>
          <PositionOption style={{ marginTop: "20px" }}>
            <RadioButton
              type="radio"
              id="top-right"
              name="logo-position"
              value="top-right"
              checked={logoPosition === "top-right"}
              onChange={(e) => setLogoPosition(e.target.value)}
            />
          </PositionOption>
          <CenterIcon>
            <PersonOutlineOutlinedIcon
              style={{ width: "80px", height: "80px" }}
            />
          </CenterIcon>
          <PositionOption style={{ marginLeft: "10px", marginBottom: "20px" }}>
            <RadioButton
              type="radio"
              id="bottom-left"
              name="logo-position"
              value="bottom-left"
              checked={logoPosition === "bottom-left"}
              onChange={(e) => setLogoPosition(e.target.value)}
            />
          </PositionOption>
          <PositionOption style={{ marginBottom: "20px" }}>
            <RadioButton
              type="radio"
              id="bottom-right"
              name="logo-position"
              value="bottom-right"
              checked={logoPosition === "bottom-right"}
              onChange={(e) => setLogoPosition(e.target.value)}
            />
          </PositionOption>
        </PositionOptions>
        <ApplyButton onClick={() => handleAddLogo()}>
          Add school logo
        </ApplyButton>
      </Dropdown>
    </SubmenuLogo>,
    document.body // The portal target
  );
};

export default SubmenuLogoComponent;
